import { render, staticRenderFns } from "./freebie-amount.vue?vue&type=template&id=24d8939e&scoped=true&"
import script from "./freebie-amount.vue?vue&type=script&lang=js&"
export * from "./freebie-amount.vue?vue&type=script&lang=js&"
import style0 from "./freebie-amount.vue?vue&type=style&index=0&id=24d8939e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8939e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
